import Icon from "components/Elements/Icon/Icon.tsx";
import Toast from "components/Elements/Toast/Toast.js";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer.js";
import Recaptcha from "../Recaptcha/Recaptcha.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useState, useRef, useEffect } from "react";
import { useToasts } from "react-toast-notifications";
import { awaiter } from "../../Pages/Home/Helpers/helpers.js";
import { RECAPTCHA_APPEAR_DELAY } from "utils/globalConsts.ts";

import "./SingleLineForm.scss";

const SingleLineForm = ({
  iconName,
  type = "text",
  placeholder = "",
  onSubmit,
}) => {
  const { addToast } = useToasts();
  const [input, setInput] = useState();
  const { getTextByKey, getBasicSettingsData } = useContent();
  const [message, setFormMessage] = useState({ message: "", status: "" });
  const recaptchaRef = useRef(null);
  const [showRecaptcha, setShowRecaptcha] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);

  const handleChange = (e) => {
    setInput(e.target.value);
  };

  const handleSubmit = async () => {
    let formResult;
    //remove message that might still be displayed from a different call
    setFormMessage({ message: "", status: "" });

    //handle form submit

    setShowRecaptcha(true);

    if (getBasicSettingsData().recaptchaType === "google" && !captchaToken) {
      await awaiter(RECAPTCHA_APPEAR_DELAY);
      await recaptchaRef.current.executeAsync();

      return;
    }

    if (!captchaToken) {
      addToast(getTextByKey("recaptcha-verification-error"), {
        appearance: "error",
      });
      return;
    }

    formResult = await onSubmit(input, captchaToken);

    if (formResult.message) {
      // we want to display a message
      setFormMessage({
        message: formResult.message,
        status: formResult.status,
      });
    }
    if (formResult.callBack) {
      // we want to call a callback
      return formResult.callBack();
    }
  };

  useEffect(() => {
    if (captchaToken) {
      handleSubmit();

      setCaptchaToken(null);
      setShowRecaptcha(false);
    }
  }, [captchaToken]);

  return (
    <div>
      <AnimationContainer
        animationOn={!message.status}
        animationClassName={`single-line-${message.status}-form-animation`}
        isUnmountOnExit={false}
        timeout={1000}
      >
        <div className="single-line-form-container">
          <input
            className="single-line-form-input"
            type={type}
            placeholder={getTextByKey(placeholder)}
            onChange={(e) => handleChange(e)}
          />
          <div
            className="single-line-form-submit-button jm-button "
            onClick={(e) => handleSubmit(e)}
          >
            <Icon name={iconName} white small></Icon>
          </div>
        </div>
      </AnimationContainer>

      <Toast
        isShow={!!message.status}
        success={message.status === "success"}
        error={message.status === "error"}
        isUnmountOnExit={false}
        timeout={3000}
      >
        {message.message}
      </Toast>
      {showRecaptcha ? (
        <Recaptcha
          recaptchaRef={recaptchaRef}
          onSuccess={(token) => setCaptchaToken(token)}
        />
      ) : null}
    </div>
  );
};

export default SingleLineForm;
